import { handleResponse, requestTimeout } from "../utils";
// import { Cookies } from 'react-cookie'

const apiUrl = process.env.REACT_APP_API_URL;
const apiMaxTime = process.env.REACT_APP_API_EXEC_TIME;
// const cookie = new Cookies();

export const userApi = {
  _get,
  _details,
  _filter,
  _add,
  _update,
  _delete,
};

async function _get(data, offset, limit) {
  // const xsrf_token = decodeURIComponent(cookie.get('XSRF-TOKEN'))
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify(data),
  };

  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "users/" + offset + "/" + limit, requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _details(id) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "users/" + id, requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _filter(type, keywords) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "user-filter/" + type + "/" + keywords, requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _add(form_data) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      // 'Content-Type': 'application/json',
      Accept: "application/json",
    },
    body: form_data,
  };
  return requestTimeout(apiMaxTime, fetch(apiUrl + "users", requestOptions))
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _update(form_data, id) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      //   "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: form_data,
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "users/" + id, requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}

async function _delete(id) {
  const token = localStorage.getItem(process.env.REACT_APP_AUTH_COOKIE);
  const requestOptions = {
    method: "DELETE",
    credentials: "include",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };
  return requestTimeout(
    apiMaxTime,
    fetch(apiUrl + "users/" + id, requestOptions)
  )
    .then(handleResponse)
    .then((response) => {
      return response;
    });
}
